<template>
  <div>

       <div v-for="(item) in pageData" :key="item.id">
            <component 
                v-if="item.widget_code == 'textarea' ||
                
                item.widget_code == 'article' ||
                item.widget_code == 'video'" 
                :is="changCom(item.widget_code)" 
                :params="item.params"
            />
            <component v-else :is="item.widget_code" :params="item.params"/>
       </div>
  </div>
</template>

<script>
import notice from "@/components/jshop/notice";
import adpop from "@/components/jshop/adpop";
import blank from "@/components/jshop/blank";
import articleClassify from "@/components/jshop/articleClassify";
import imgSingle from "@/components/jshop/imgSingle";
import imgSlide from "@/components/jshop/imgSlide";
import videoList from "@/components/jshop/videoList";
import news from "@/components/jshop/news";
import pcLoft from "@/components/jshop/pcLoft";
import pcgoods from "@/components/jshop/pcgoods";


import textareaCom from "@/components/jshop/textareaCom";
import videoCom from "@/components/jshop/videoCom";
import articleCom from "@/components/jshop/articleCom";



export default {
    components: {
        notice,
        adpop,
        blank,
        articleClassify,
        imgSingle,
        textareaCom,
        videoCom,
        imgSlide,
        videoList,
        articleCom,
        news,
        pcLoft,
        pcgoods
    },
    props: {
        pageData: {
            type: Array
        }
    },
    methods: {
        changCom(v) {
            return v + 'Com'
        },
       
    }

}
</script>

<style>

</style>